import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'tooltip-icon-button',
  templateUrl: 'tooltip-icon-button.component.html',
  styleUrls: ['tooltip-icon-button.component.scss'],
})
export class TooltipIconButtonComponent {

  @Input() tooltipText: string = 'Woooo';
  @Input() disabled: boolean = false;
}
